<template>
  <div class="flex min-w-0 flex-col" :data-testid="testId">
    <span
      class="font-mono font-bold leading-none tabular-nums"
      :class="[size === 'lg' ? 'text-2xl' : 'text-lg', AFFILIATE_SLA_TEXT_CLASS[clock.tone]]"
      :data-testid="`${testId}-value`"
    >
      {{ clock.value }}
    </span>
    <span v-if="clock.due" class="mt-1 text-[11px] text-neutral50" :data-testid="`${testId}-due`">
      {{ clock.due }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { packageClock } from '../format'
import type { PackageClockInput } from '../format'
import { AFFILIATE_SLA_TEXT_CLASS } from '../labels'

const props = withDefaults(
  defineProps<{ row: PackageClockInput; nowMs: number; size?: 'md' | 'lg'; testId?: string }>(),
  { size: 'md', testId: 'affiliate-package-clock' }
)

const clock = computed(() => packageClock(props.row, props.nowMs))
</script>
